import React, { useState } from "react";
import MyModal from "../Common/MyModal";
import { Button, Dropdown, Form, FormCheck } from "react-bootstrap";
import {
  useCloseEventMutation,
  useCloseNoSolutionEventMutation,
  useGetEventSolutionsQuery,
  useUpdateEventStatusMutation,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";
import { useDispatch } from "react-redux";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function EventCloseEventModal({ eventData, eventSolution }) {
  const [closeSolutionEvent] = useCloseEventMutation();
  const [closeNoSolutionEvent] = useCloseNoSolutionEventMutation();
  const [setEventStatus] = useUpdateEventStatusMutation();
  const confirmDialog = useConfirmDialog();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState();
  const [status, setStatus] = useState();

  return (
    <MyModal
      label=" Close Event"
      buttonClassName="bg-colored-reverse px-3 btn-sm rounded-pill border-0 fw-bold text-nowrap text-white p-1"
      heading="Close Event"
      key={reset}
    >
      {({ handleClose }) => (
        <>
          <div className="bg-white p-3 rounded-2 my-3">
            <AbsoluteLoadingIndicator loading={loading} />

            <Form.Group className="mb-3" controlId="closeEventTextarea">
              <Form.Label>
                Why do you want to close the event?(optional)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </Form.Group>
          </div>
          <Form.Select
            className="mb-3"
            aria-label="Close Reason Select"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">Select Reason for Closing</option>
            <option value="resolved"> Resolved</option>
            <option value="false_alarm">Closed</option>
          </Form.Select>
          <div className="d-flex gap-3 justify-content-center">
            <div className="">
              <Button
                className="bg-colored-reverse px-3 rounded-pill  border-0 btn-sm fw-bold mt-3"
                onClick={() => setReset(Date.now())}
                disabled={loading}
              >
                <div className="text-white"> Cancel</div>
              </Button>
            </div>
            <div className="">
              {eventSolution?.Features?.some(
                (f) => f.Feature === "close-event" && f.Status === "enabled"
              ) ? (
                <Button
                  className="bg-colored-reverse px-3 rounded-pill  border-0 btn-sm fw-bold mt-3"
                  onClick={async () => {
                    setLoading(true);
                    await closeSolutionEvent({
                      SolutionClientUuid: eventSolution.Uuid,
                      ID: eventData.Reference,
                      Message: message,
                      Status: status,
                    })
                      .then((res) => {
                        if ("data" in res) {
                          toast.success("Event closed successfully");
                          handleClose();
                        }
                      })
                      .finally(() => {
                        setTimeout(() => {
                          setLoading(false);
                        }, 500);
                      });
                  }}
                  disabled={loading}
                >
                  <div className="text-white"> Close Event</div>
                </Button>
              ) : (
                <Button
                  className="bg-colored-reverse px-3 rounded-pill  border-0 btn-sm fw-bold mt-3"
                  onClick={async () => {
                    setLoading(true);
                    await closeNoSolutionEvent({
                      SolutionClientUuid: eventSolution.Uuid,
                      ID: eventData.Reference,
                      Message: message,
                      Status: status,
                    })
                      .then((res) => {
                        if ("data" in res) {
                          toast.success("Event closed successfully");
                          handleClose();
                        }
                      })
                      .finally(() => {
                        setTimeout(() => {
                          setLoading(false);
                        }, 500);
                      });
                  }}
                  disabled={loading}
                >
                  <div className="text-white"> Close Event</div>
                </Button>
              )}
            </div>
          </div>
        </>
      )}
    </MyModal>
  );
}
